import React from "react";
import ActivityIcon from "../Icons/ActivityIcon";
import BannerIcon from "../Icons/BannerIcon";
import BarIcon from "../Icons/BarIcon";
import CustIcon from "../Icons/CustIcon";
import DashBIcon from "../Icons/DashBIcon";
import FranchiseIcon from "../Icons/FranchiseIcon";
import LogIcon from "../Icons/LogIcon";
import MerchIcon from "../Icons/MerchIcon";
import ProdIcon from "../Icons/ProdIcon";
import SandBox from "../Icons/SandBox";
import SettingsIcon from "../Icons/SettingsIcon";
import TransIcon from "../Icons/TransIcon";
import UserRoleIcon from "../Icons/UserRoleIcon";
import "./Menu.css";

export default function Menu() {
  return (
    <div className="Menu-Full">
      <div className="menu-header">
        <FranchiseIcon />
        <p>Frienchised</p>
      </div>
      <div className="menu-sub-header">
        <div className="menu-sub-header-1">
          <ProdIcon />
          <p>Production</p>
        </div>
        <div className="menu-sub-header-1">
          <SandBox />
          <p>SandBox</p>
        </div>
      </div>
      <img></img>
      <div className="sub-menu">
        <p className="Menu-menu">Menu</p>
        <div className="sub-menu-1-active">
          <DashBIcon />
          <p>DashBoard</p>
        </div>
        <div className="sub-menu-1">
          <CustIcon />
          <p>Customer</p>
        </div>
        <div className="sub-menu-1">
          <ActivityIcon />
          <p>Activity</p>
        </div>
        <div className="sub-menu-1">
          <MerchIcon />
          <p>Merchant</p>
        </div>
        <div className="sub-menu-1">
          <TransIcon />
          <p>Transaction</p>
        </div>
        <div className="sub-menu-1">
          <LogIcon />
          <p>Log Activity</p>
        </div>
        <div className="sub-menu-1">
          <BannerIcon />
          <p>Banner Promo</p>
        </div>
      </div>
      <div className="sub-menu-2">
        <div className="sub-menu-1">
          <UserRoleIcon />
          <p>User Role Admin</p>
        </div>
        <div className="sub-menu-1">
          <SettingsIcon />
          <p>Settings</p>
        </div>
      </div>
    </div>
  );
}
